export const AWS_S3 = "https://primecx.s3.amazonaws.com";
export const LARAVEL_URL="https://dashboard.primecx.ai/api"
//export const LARAVEL_URL="https://primecx.doyenhub.com/api"
//export const LARAVEL_URL="http://192.168.2.24:1215/api"
